<div class="admin-container">
  <!-- Message mobile uniquement -->
  <div class="mobile-warning">
    <i class="bi bi-exclamation-triangle"></i>
    <h3>Panel Admin non disponible sur mobile</h3>
    <p>Veuillez utiliser un écran plus large</p>
  </div>

  <!-- Sidebar -->
  <aside class="admin-sidebar" [class.collapsed]="sidebarCollapsed">
    <div class="sidebar-header">
      <div class="logo">
        <i class="bi bi-shield-check"></i>
        @if(!sidebarCollapsed) {
          <span>Admin Panel</span>
        }
      </div>
      <button class="toggle-btn" (click)="toggleSidebar()">
        <i class="bi" [class.bi-chevron-left]="!sidebarCollapsed" [class.bi-chevron-right]="sidebarCollapsed"></i>
      </button>
    </div>

    <nav class="sidebar-nav">
      <a routerLink="/admin/users" routerLinkActive="active" class="nav-item">
        <i class="bi bi-people"></i>
        @if(!sidebarCollapsed) {
          <span>Utilisateurs</span>
        }
      </a>
      
      <a routerLink="/admin/companies" routerLinkActive="active" class="nav-item">
        <i class="bi bi-building"></i>
        @if(!sidebarCollapsed) {
          <span>Sociétés</span>
        }
      </a>

      <div class="nav-divider"></div>
    </nav>

    <div class="sidebar-footer">
      <a (click)="logout()" class="nav-item logout">
        <i class="bi bi-box-arrow-right"></i>
        @if(!sidebarCollapsed) {
          <span>Déconnexion</span>
        }
      </a>
    </div>
  </aside>

  <!-- Main Content -->
  <main class="admin-main" [class.sidebar-collapsed]="sidebarCollapsed">
    <div class="admin-content">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>